import { Link, useNavigate } from "react-router-dom";

import stu from "../../../images/stu.svg";

import { useState } from "react";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Selected from "../../Inputs/Selected";
import Input from "../../Inputs/Input";
import Card from "../../Cards/Card";
import CardHall from "../../Cards/CardHall";
import ButtonRed from "../../Buttons/Buttonred";

type FormData = {
  name: string;
  date: string;
};

export default function Distribution_students() {
  const navigate = useNavigate();
  const [sure, setSure] = useState(false);

  return (
    <>
      <Row>
        <Col>
          <Title title="توزيع الطلاب على القاعات الامتحانية" />
        </Col>
      </Row>
      <Row>
        <Col lg={11} sm={11} md={5} className={"mx-5 max-md:!mx-auto"}>
          <Selected
            title=" اسم المقرر "
            text="أختر اسم المقرر"
            // value={formData.name}
            // onChange={(e) => {
            //   handleChangeInput(e);
            // }}
          >
            <option>React</option>
            <option>HTML</option>
            <option>CSS</option>
            <option>JS</option>
          </Selected>
        </Col>
        <Col lg={11} sm={11} md={5} className="mx-5 max-md:!mx-auto">
          <Input
            type="date"
            title="حدد التاريخ"
            name="date"
            // value={formData.date}
            // onChange={handleChangeInput}
          />
        </Col>
      </Row>

      <Row justify="start">
        <Col md={5} sm={10} lg={3} className="lg:mx-5 ">
          <Link to="/registered_students">
            <Card title={"عدد الطلاب المسجلين"} sum={300} image={stu} />
          </Link>
        </Col>
      </Row>

      <Row className="!mt-4 !mx-3">
        <Title title="اختر القاعة" />
      </Row>

      <Row>
        <Col lg={3} md={4}>
          <CardHall
            check={true}
            title={"اسم القاعة"}
            CapacityHall={"استطاعة القاعة"}
            watt={true}
          />
        </Col>
        <Col lg={3} md={4}>
          <CardHall
            check={true}
            title={"اسم القاعة"}
            CapacityHall={"استطاعة القاعة"}
            watt={true}
          />
        </Col>
        <Col lg={3} md={4}>
          <CardHall
            check={true}
            title={"اسم القاعة"}
            CapacityHall={"استطاعة القاعة"}
            watt={true}
          />
        </Col>
        {/* Render more CardHall components */}
      </Row>
      <Row>
        <Col lg={11} md={7} className="flex justify-end !mt-5 max-lg:mx-auto">
          <div
            className="bg-[#BE68A9] text-white font-bold text-center w-[400px] cursor-pointer rounded-2xl max-md:mx-auto py-3 "
            onClick={() => setSure(true)}
          >
            توزيع
          </div>
        </Col>
      </Row>

      {sure && (
        <>
          <div
            className="fixed top-0 left-0 h-[105px] z-30"
            onClick={() => setSure(false)}
          />
          <div
            className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 border-2 border-Third bg-[#f5f5f5] rounded-lg z-40 flex justify-center items-center max-sm:w-full`}
          >
            <div className="bg-slate-50 z-[60] rounded-3xl w-[600px] max-w-[500px] min-h-[180px]">
              <p className="font-semibold text-xl text-center py-7">
                هل انت متأكد من توزيع الطلاب على هذه القاعات ؟
              </p>
              <div className="flex items-center justify-center gap-3 m-5">
                <ButtonRed
                  className="py-3 bg-[#BE68A9]"
                  onClick={() => setSure(false)}
                  name="نعم"
                />
                <ButtonRed
                  className="mx-2 !px-2 font-semibold border-2 !bg-white !text-Secondary hover:!bg-[#BE68A9] hover:!text-white rounded-xl ml-5"
                  onClick={() => setSure(false)}
                  name=" إلغاء"
                />
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
